import { useCallback, useEffect, useState } from "react"

import { cmsSeoService } from "services/cms-seo/cms-seo.service"
import { CmsPageListItem, CmsPageListQuery } from "services/cms-seo/type"

export type PageListFilters = Omit<CmsPageListQuery, "page" | "pageSize">

interface UsePageListResult {
  rows: CmsPageListItem[]
  loading: boolean
  page: number
  pageSize: number
  total: number
  totalPages: number
  setPage: (page: number) => void
  setPageSize: (size: number) => void
  refresh: () => void
}

export const usePageList = (filters: PageListFilters, pageSizeDefault = 10): UsePageListResult => {
  const [rows, setRows] = useState<CmsPageListItem[]>([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(pageSizeDefault)
  const [total, setTotal] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [refreshKey, setRefreshKey] = useState(0)

  const filterKey = JSON.stringify(filters)

  useEffect(() => {
    setPage(1)
  }, [filterKey, pageSize])

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      setLoading(true)
      const data = await cmsSeoService.listPages({ ...filters, page, pageSize })
      if (cancelled) return
      setRows(data.items)
      setTotal(data.total)
      setTotalPages(data.total_pages)
      setLoading(false)
    }

    load()
    return () => {
      cancelled = true
    }
    // filterKey stands in for the object, so a fresh literal does not refetch.
  }, [filterKey, page, pageSize, refreshKey])

  const refresh = useCallback(() => setRefreshKey((key) => key + 1), [])

  return { rows, loading, page, pageSize, total, totalPages, setPage, setPageSize, refresh }
}
